import { render, staticRenderFns } from "./EnrolleeCardBack.vue?vue&type=template&id=655e4929&scoped=true&"
import script from "./EnrolleeCardBack.vue?vue&type=script&lang=js&"
export * from "./EnrolleeCardBack.vue?vue&type=script&lang=js&"
import style0 from "./EnrolleeCardBack.vue?vue&type=style&index=0&id=655e4929&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e4929",
  null
  
)

export default component.exports